module.exports = __webpack_public_path__ + "img/logo.44d821ac.png";